import {ReactNode, useEffect, useState} from 'react'
import {selectGlobalDialogState} from '../../../../../redux/ducks/GlobalDialog/slice';
import {useAppSelector} from '../../../../../redux/hooks';
import ArgosCollapseComponent from '../../../../components/CollapseComponent/ArgosCollapseComponent';
import ArgosFlexbox from '../../../../components/Containers/ArgosFlexbox';
import ArgosTextField from '../../../../components/Form/TextField/ArgosTextField';
import { Lidar } from '../../constants';


interface LidarDescriptionProps {
  sensor: Lidar
}

const SensorDescription = (props: LidarDescriptionProps) => {
  const [sensorDescriptionDataMap, setDataMap] = useState<any>({})
  const [radarDescriptionData, setRadarDescriptionData] = useState(props.sensor)
  useEffect(() => {
    makeTabs()
  }, [])

  const makeTabs = () => {
    const dataMap: object = {
      'General Information': processGeneralInfoData(),
      'Sensitivity, Range, Field of View': processSRFOVInfoData(),
      'Link Budget': processLinkBudgetInformation(),
      'Reflectivity Improvement': processReflectivityImprovementInformation()
    }
    setDataMap(dataMap)
  }

  function processGeneralInfoData() {
    const generalInfoLabelsMapping: object[] = [
      {'Supplier Name': 'supplier'},
      {'Component Name': 'component'},
      {'Component Type': 'lidarType'},
      {'Component Version/Revision': 'componentVersion'}]

    return mapLabelToLidarValue(generalInfoLabelsMapping)

  }

  function processSRFOVInfoData() {
    const SRFOVInfoLabels = [
      {'Sensor degradation due to manufacturing variation (dB)': 'detectionDegradation'},
      {'Maximum instrumented range (m)': 'maxInstrumentedRange'},
      {'Maximum instrumented field of view - Azimuth (+/- deg)': 'azimuthFOV'},
      {'Maximum instrumented field of view - Elevation (+/- deg)': 'elevationFOV'}
    ]
    return mapLabelToLidarValue(SRFOVInfoLabels)
  }

  function processLinkBudgetInformation() {
    const linkBudgetInfo = [
      {' Transmit power at hot (i.e., at max MMIC junction temperature, Tj )': 'txPowerHot'},
      {'Wavelength': 'wavelength'},
      {'Number of total transmit and receive channels? ': 'numTxRxChannels'},
      {'Modulation scheme description': 'modulationScheme'},
      {'Total FOV scan time': 'totalFOVScanTime'},
    ]
    return mapLabelToLidarValue(linkBudgetInfo)
  }
function processReflectivityImprovementInformation() {
    const relfectivityImprovementInfo = [
      {'Improvement in detection range at boresight for a glossy white paint (58%) vs glossy black paint (0.1%) vehicle target.': 'reflectivityImprovement'},
    ]
    return mapLabelToLidarValue(relfectivityImprovementInfo)
  }
  
  function mapLabelToLidarValue(mappingList: object[]) {
    const returnList: any[] = []
    mappingList.forEach((labelObject: object) => {
      returnList.push({
        'label': Object.keys(labelObject)[0],
        'value': radarDescriptionData[Object.values(labelObject)[0] as keyof Lidar]
      })
    })
    const returnComponent: ReactNode = <ArgosFlexbox
      style={{display: "flex", flexFlow: 'row wrap', justifyContent: "center", maxWidth: "90%"}}>
      {returnList.map((mapElement, index) =>
        <ArgosTextField
          key={index}
          style={{width: "600px", gap: "10px 10px"}}
          value={mapElement.value}
          name={mapElement.label}
          id="outlined-basic"
          label={mapElement.label}
          variant="outlined"
          size="small"
          className='grid-item'
          InputProps={{
            readOnly: true,
          }}/>)
      }
    </ArgosFlexbox>

    return returnComponent
  }

  return (
    <ArgosCollapseComponent componentType="sensorDescription" data={sensorDescriptionDataMap}/>
  )
}
export default SensorDescription;